import Model from "./base/model";

class MessagesQuotes extends Model{
  resourceName() {
    return "messages_quotes";
  }

  fields() {
    return {
      text: "",
      simulation_quotes_transporter_id: "",
      user_id: "",
      company: { jsonApi: "hasOne", type: "companies"},
      user: { jsonApi: "hasOne", type: "users"},
      simulation_quotes_transporter: { jsonApi: "hasOne", type: "simulation_quotes_transporters"},
    };
  }
}

export default new MessagesQuotes();
